class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]:not(.voice-search__button)').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.querySelector('button[type="reset"]').addEventListener(
      'click',
      this.reset.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
  }

  open() {
    setScrollbarWidth();
    setHeaderBottomPosition();

    /* AG V2 IOS SEARCH VIEWPORT LOCK 2026-10-07 */
    if (window.matchMedia('(max-width: 749px)').matches) {
      this.agv2SearchScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.style.setProperty('--agv2-search-scroll-y', this.agv2SearchScrollY + 'px');
      this.agv2SyncViewport = () => {
        const viewport = window.visualViewport;
        const height = viewport ? viewport.height : window.innerHeight;
        const offsetTop = viewport ? viewport.offsetTop : 0;
        document.documentElement.style.setProperty('--agv2-search-vvh', height + 'px');
        document.documentElement.style.setProperty('--agv2-search-vvo', offsetTop + 'px');
      };
      this.agv2SyncViewport();
      window.visualViewport?.addEventListener('resize', this.agv2SyncViewport);
      window.visualViewport?.addEventListener('scroll', this.agv2SyncViewport);
    }

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close() {
    removeTrapFocus();
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('search-modal--open');

    if (this.agv2SyncViewport) {
      window.visualViewport?.removeEventListener('resize', this.agv2SyncViewport);
      window.visualViewport?.removeEventListener('scroll', this.agv2SyncViewport);
      this.agv2SyncViewport = null;
    }
    const restoreY = this.agv2SearchScrollY;
    this.agv2SearchScrollY = null;
    document.documentElement.style.removeProperty('--agv2-search-scroll-y');
    document.documentElement.style.removeProperty('--agv2-search-vvh');
    document.documentElement.style.removeProperty('--agv2-search-vvo');
    if (typeof restoreY === 'number') requestAnimationFrame(() => window.scrollTo(0, restoreY));

    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    event.preventDefault();
    this.querySelector('input[type="search"]').value = '';
  }
}

customElements.define('search-modal', SearchModal);
